import { createSlice } from '@reduxjs/toolkit';
import logger from 'ws-scripts/modules/logger';
import {
	DEFAULT_RADIUS,
	SESSION_STORAGE_KEY,
	MILE_RANGES
} from '../constants/filterConstants';

const LOG_PREFIX = '[ws-locations-facets][facetsSlice]';

const getInitialRadius = () => {
	try {
		if (typeof window === 'undefined') {
			return DEFAULT_RADIUS;
		}

		const stored = sessionStorage.getItem(SESSION_STORAGE_KEY);
		if (!stored) {
			return DEFAULT_RADIUS;
		}

		const parsed = parseInt(stored, 10);

		if (Number.isNaN(parsed)) {
			logger.warn(
				`${LOG_PREFIX} Invalid radius in sessionStorage:`,
				stored
			);
			return DEFAULT_RADIUS;
		}

		if (!MILE_RANGES.includes(parsed)) {
			logger.warn(`${LOG_PREFIX} Radius not in valid ranges:`, parsed);
			return DEFAULT_RADIUS;
		}

		return parsed;
	} catch (error) {
		logger.warn(
			`${LOG_PREFIX} Failed to read radius from sessionStorage:`,
			error
		);
		return DEFAULT_RADIUS;
	}
};

const initialState = {
	radius: getInitialRadius()
};

const facetsSlice = createSlice({
	name: 'facets',
	initialState,
	reducers: {
		radiusChanged(state, action) {
			const newRadius = action.payload;

			if (typeof newRadius !== 'number' || Number.isNaN(newRadius)) {
				logger.error(`${LOG_PREFIX} Invalid radius value:`, newRadius);
				return;
			}

			if (!MILE_RANGES.includes(newRadius)) {
				logger.error(
					`${LOG_PREFIX} Radius not in valid ranges:`,
					newRadius
				);
				return;
			}

			// eslint-disable-next-line no-param-reassign
			state.radius = newRadius;
		},
		/**
		 * Sync radius from an external widget (e.g. ws-locations-search).
		 * Only updates Redux state — middleware intentionally ignores this
		 * action so it won't duplicate search / sessionStorage / events.
		 */
		radiusSynced(state, action) {
			const newRadius = action.payload;

			if (typeof newRadius !== 'number' || Number.isNaN(newRadius)) {
				return;
			}

			if (!MILE_RANGES.includes(newRadius)) {
				return;
			}

			// eslint-disable-next-line no-param-reassign
			state.radius = newRadius;
		}
	}
});

export const { radiusChanged, radiusSynced } = facetsSlice.actions;

export default facetsSlice.reducer;
